import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';

const SET_POST_FTUX_TYPE: string = 'set_post_ftux';

export type SetPostFtuxPayload = {
  feature_highlights: boolean;
  onboarding_complete?: boolean;
};

export const setPostFtux = (body: SetPostFtuxPayload) =>
  SocketAsFetch.fetch({
    message_type: SET_POST_FTUX_TYPE,
    info: body,
  });
